import React from 'react';
import { Title } from 'app/components/Typography/Title';
import FormItem from 'app/components/Form/FormItem';
import Input from 'app/components/Input';
import FormItemSections from '../../FormItemSections';
import styled from '@emotion/styled';

const Container = styled.div`
  h5 {
    margin-bottom: 8px;
  }

  .ant-form-item-row {
    margin-top: 24px;

    > div {
      > label {
        font-size: 14px;
        font-weight: 500;
        line-height: 16px;
        letter-spacing: 0.03em;
        text-align: left;
      }
    }
  }
`;

type SectionProps = {
  selected: boolean;
  name: string;
};
type Props = {
  initialValues: {
    name: string;
    criteria: Array<SectionProps>;
  };
};
const Information = (props: Props) => {
  return (
    <Container>
      <Title level={4}>Template Information</Title>
      <FormItem label="New Template Name" name="name">
        <Input></Input>
      </FormItem>

      <FormItem label="Criteria:" name="scheme">
        <FormItemSections {...props}></FormItemSections>
      </FormItem>
    </Container>
  );
};

export default Information;
